import { connect } from 'react-redux'
import { useEffect, useRef, useState } from 'react'
import Feather from '@sysunite/react-feather'
import { Checkbox, Row, Col, Slider, Select, Tooltip, Button } from 'antd'
import './TimeVisualizer.scss'
import { getUid, getAttributeKeyLabel } from 'Services/WeaverUtils'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { setFilteredRelationsByOther, setFilteredNodesByOther } from 'Actions/graphFilter'
import moment from 'moment'
import { splitUid} from 'Services/WeaverUtils'
import { HistoryOutlined } from '@ant-design/icons'
import {
  setUseEndDateAttribute,
  setSelectedAttribute,
  setSelectedEndAttribute,
  setStepSize
} from 'Actions/timeVisualization'

nodeSelector = createSelector((state) ->
  state.graph.graphData.nodes
, (node) -> node)

edgeSelector = createSelector((state) ->
  state.graph.graphData.edges
, (edge) -> edge)

TimeVisualizer = ({
  selectedAttribute,
  selectedEndAttribute,
  stepSize,
  filteredNodesByOther,
  setSelectedAttribute,
  setSelectedEndAttribute,
  setStepSize,
  setFilteredNodesByOther
  setFilteredRelationsByOther
  setUseEndDateAttribute
  useEndDateAttribute
}) ->
  [active, setActive] = useState(false)
  [loading, setLoading] = useState(false)
  [currentNodes, setCurrentNodes] = useState([])
  [attributes, setAttributes] = useState([])
  [range, setRange] = useState([])
  [tooltipVisible, setTooltipVisible] = useState(false)
  [max, setMax] = useState(0)
  [sliderVal, setSliderVal] = useState([0, 0])
  [playbackTimer, setPlaybackTimer] = useState(undefined)
  [shouldAnimate, setShouldAnimate] = useState(false)
  [pristine, setPristine] = useState(true)
  [withRelations, setWithRelations] = useState(false)

  stepSizes = [
    'hour'
    'day'
    'week'
    'month'
    'year'
  ]

  getDateRange = (nodes, attributeKey) ->
    Weaver.MetaQueries.attributeMinMax(attributeKey, nodes)

  getAttributeKeys = (nodes) ->
    Weaver.MetaQueries.attributeKeysForNodes(nodes, { limit: 99999 })

  classNames = ['time-visualization']
  nodeIds = _.map(useSelector(nodeSelector), 'id')
  edgeIds = _.map(useSelector(edgeSelector), 'id')

  formatDate = (date) ->
    moment(date).format('YYYY-MM-DD HH:mm:ss')

  getIds = (ids) ->
    _.map(ids, (id) ->
      [id, graph] = splitUid(id)
      Weaver.Node.get(id, (if withRelations then Weaver.RelationNode), graph)
    )

  useEffect(->
    (->
      if active
        setLoading(true)

        nodes = _.map((if withRelations then edgeIds else nodeIds), (id) ->
          [id, graph] = splitUid(id)
          if withRelations
            WeaverNode = Weaver.RelationNode
          else
            WeaverNode = Weaver.Node

          WeaverNode.get(id, { graph })
        )
        setAttributes(await getAttributeKeys(nodes))

      setLoading(false)
    )()
    undefined
  , [active, withRelations])


  useEffect(->
    (->
      if selectedAttribute?
        setFilteredNodesByOther([])
        setFilteredRelationsByOther([])
        nodes = _.map((if withRelations then edgeIds else nodeIds), (id) ->
          [id, graph] = splitUid(id)
          if withRelations
            WeaverNode = Weaver.RelationNode
          else
            WeaverNode = Weaver.Node
          WeaverNode.get(id, { graph })
        )

        startResult = await getDateRange(nodes, selectedAttribute)
        if useEndDateAttribute
          endResult = await getDateRange(nodes, selectedEndAttribute)

        query = new Weaver.Query()
          .restrict(if withRelations then getIds(edgeIds) else getIds(nodeIds))
          .exists(selectedAttribute)

        query.withRelations() if withRelations

        setCurrentNodes(await query.unlimited())

        calculateRange(startResult.min, if useEndDateAttribute then endResult.max else startResult.max)
    )()
    undefined
  , [withRelations, selectedAttribute, selectedEndAttribute])

  useEffect(->
    [minVal, maxVal] = sliderVal
    if maxVal is range.length - 1 and playbackTimer?
      stopPlayback()

    filterNodes() if shouldAnimate

    undefined
  , [sliderVal])

  calculateRange = (min, max) ->
    minDate = moment(min)
    maxDate = moment(max)
    difference = maxDate.diff(minDate, stepSize)

    newRange = _.map([0..difference], (val) ->
      if val is 0
        minDate
      else if val is difference
        maxDate
      else
        moment(minDate).add(val, stepSize).minutes(0).seconds(0)
    )

    setRange(newRange)
    setMax(rangeLength = newRange.length - 1)
    setSliderVal([0, rangeLength])

  useEffect(->
    if selectedAttribute? and currentNodes.length > 0
      setSliderVal([0, 0])
      calculateRange(_.first(range), _.last(range))
    undefined
  , [stepSize])

  filterNodes = ->
    [minVal, maxVal] = sliderVal
    minDate = range[minVal]
    maxDate = range[maxVal]

    if withRelations
      reducerFn = setFilteredRelationsByOther
    else
      reducerFn = setFilteredNodesByOther

    reducerFn(
      _.map(
        _.filter(currentNodes, (node) ->

          startDate = node.get(selectedAttribute)
          endDate = node.get(selectedEndAttribute)

          not startDate.isBetween(minDate, maxDate, undefined, '[]') or
            (if useEndDateAttribute and endDate? then endDate.isSameOrBefore(maxDate) else false)
        )
      , getUid)
    )

  play = ->
    setPristine(false)
    setPlaybackTimer(
      setInterval(->
        setSliderVal((val) ->
          [val[0], val[1] + 1]
        )
      , 500)
    )

  startPlayback = ->
    [minVal, maxVal] = sliderVal
    if playbackTimer?
      setShouldAnimate(false)
      stopPlayback()
    else if maxVal is range.length - 1 and not playbackTimer?
      setShouldAnimate(true)
      setSliderVal([minVal, minVal])
      play()
    else
      setShouldAnimate(true)
      play()

  stopPlayback = ->
    clearInterval(playbackTimer)
    setPlaybackTimer(undefined)


  if active
    classNames.push('is-open')

  stepButtonTooltip = (direction) ->
    <>
      <div>Click: Step { direction } once</div>
      <div>Shift+Click: Step lower value { direction } once</div>
    </>

  AttributeSelect = ({ onSelect, value, placeholder }) ->
    <Select
      onSelect={onSelect}
      loading={loading}
      placeholder={placeholder}
      disabled={playbackTimer?}
      value={value}
      bordered={false}
    >
      {
        _.map(attributes, (attribute) ->
          <Select.Option value={attribute} key={attribute}>
            { getAttributeKeyLabel(attribute) }
          </Select.Option>
        )
      }
    </Select>

  <div className={classNames.join(' ')}>
    <Row gutter={8}>
      <Col>
        <Tooltip
          placement="bottomLeft"
          trigger="hover"
          mouseEnterDelay={1}
          visible={not active and tooltipVisible}
          title="Visualize time in the graph for a specific attribute"
          onVisibleChange={setTooltipVisible}>
          <Button
            className={active and playbackTimer? and filteredNodesByOther.length > 0 && 'active'}
            type="link"
            onClick={->
              setActive(not active)
            }
            icon={<Feather size="1.5em" type="clock" />}        />
        </Tooltip>
      </Col>
      {
        if active
          objType = if withRelations then 'relations' else 'nodes'
          <Col className="timebar" flex={1}>
            <Checkbox
              style={{ padding: '0px 11px' }}
              checked={withRelations}
              onChange={({ target: { checked }}) -> setWithRelations(checked)}
            >Use relations</Checkbox>
            <AttributeSelect
              key={'selectBefore'}
              value={selectedAttribute}
              onSelect={setSelectedAttribute}
              placeholder={"Hide #{objType} before"}
            />
            <Checkbox
              style={{ padding: '0px 11px' }}
              checked={useEndDateAttribute}
              onChange={({ target: { checked }}) -> setUseEndDateAttribute(checked)}
            >Hide { objType } after...</Checkbox>
            {
              if useEndDateAttribute
                <AttributeSelect
                  key={'selectAfter'}
                  value={selectedEndAttribute}
                  onSelect={setSelectedEndAttribute}
                  placeholder={"Hide #{objType} after"}
                />
            }
            <Row>
              <Col flex={1}>
                <Row>
                  <Col>
                    <Tooltip
                      title={stepButtonTooltip("back")}
                      trigger="hover"
                      mouseEnterDelay={1}
                    >
                      <Button
                        disabled={playbackTimer?}
                        onClick={(e) ->
                          e.persist()
                          setShouldAnimate(true)
                          setSliderVal((val) ->
                            if e.shiftKey
                              [Math.max(val[0] - 1, 0), val[1]]
                            else
                              [val[0], Math.max(val[1] - 1, val[0])]
                          )
                        }
                        type="link"
                        icon={<Feather type="skip-back" />} />
                    </Tooltip>
                  </Col>
                  <Col flex={1}>
                    <Slider
                      max={max}
                      value={sliderVal}
                      onChange={(val) ->
                        setShouldAnimate(true)
                        setSliderVal(val)
                      }
                      tipFormatter={(val) -> formatDate(range[val])}
                      tooltipPlacement="bottom"
                      range={true}
                      disabled={not selectedAttribute?} />
                  </Col>
                  <Col>
                    <Tooltip
                      title={stepButtonTooltip("forward")}
                      trigger="hover"
                      mouseEnterDelay={1}
                    >
                      <Button
                        disabled={playbackTimer?}
                        onClick={(e) ->
                          e.persist()
                          setShouldAnimate(true)
                          setSliderVal((val) ->
                            if e.shiftKey
                              [Math.min(val[0] + 1, val[1]), val[1]]
                            else
                              [val[0], Math.min(val[1] + 1, max)]
                          )
                        }
                        type="link"
                        icon={<Feather type="skip-forward" />} />
                    </Tooltip>
                  </Col>
                </Row>
              </Col>
              <Col>
                <Button
                  type="link"
                  onClick={startPlayback}
                  disabled={not selectedAttribute?}
                  icon={
                    <Feather
                      type={
                        if playbackTimer?
                          "pause"
                        else if sliderVal[1] is range.length - 1 and not pristine
                          "rotate-ccw"
                        else
                          "play"
                      } />
                  }/>
              </Col>
            </Row>
            <Row align="middle" gutter={8}>
              <Col flex={1}>
                <Select
                  style={{ width: '100%' }}
                  onSelect={setStepSize}
                  placeholder="Step size"
                  disabled={playbackTimer?}
                  suffixIcon={<HistoryOutlined />}
                  value={stepSize}
                  bordered={false}>
                  {
                    _.map(stepSizes, (stepSizeVal) ->
                      <Select.Option value={stepSizeVal} key={stepSizeVal}>
                        { stepSizeVal }
                      </Select.Option>
                    )
                  }
                </Select>
              </Col>
            </Row>
          </Col>
      }
    </Row>
  </div>

export default connect(
  ({
    graphFilter: { filteredNodes: { byOther }},
    timeVisualization: { useEndDateAttribute, selectedAttribute, selectedEndAttribute, stepSize }
  }) ->
    { useEndDateAttribute, selectedAttribute, selectedEndAttribute, stepSize, filteredNodesByOther: byOther }
, { setFilteredRelationsByOther, setUseEndDateAttribute, setSelectedAttribute, setSelectedEndAttribute, setStepSize, setFilteredNodesByOther }
)(TimeVisualizer)
